import React from 'react'
import { styles } from './styles'

function Loading({ style }) {
  const Image_Http_URL = `${process.env.REACT_APP_MEDIA_DOMAIN}/telva/img/spinner-telvashopper.gif`
  return (
    <div style={{ ...styles.container, ...style }}>
      <img src={Image_Http_URL} style={styles.image} />
    </div>
  )
}

export { Loading }
